<template>
    <div class='ineract-wrapper primary-text-26 cant-select' ref='sign'>
        <div class='left item'>
            <div class='wechat primary-bd-ca' @mouseenter="handleWechatSelect" @mouseleave="closeShowQrcode">
                <div>微信扫一扫</div>
                <div class='weixin'>
                </div>
            </div>
            <div class='copy primary-bd-ca' v-copy='{value: qrImg, cb: copyCb}'>
                <div>复制链接</div>
                <div class='link'>
                </div>
            </div>
        </div>
        <div class='right item'>
            <div class='assist primary-bd-ca' :class='{ "assisted": flag != 0 }' @click='handleZanClick'>
                <div class='desc'>赞{{likes > 0 ? `(${likes})` : ''}}</div>
                <div class='praise'>
                </div>
            </div>
            <div class='primary-bd-ca' :class='{"belittle": isDislike}' @click="handleZaClick">
                <div class='desc'>砸</div>
                <div class='belittle'>
                </div>
            </div>
        </div>
        <div class='qr-block sub-bg-ff card-shadow-gray' v-show='isShowQrcode'>
            <div class='share primary-text-26'>
                <div class="item">
                    <div class='img wechat'>

                    </div>
                    <div class='msg'>分享到微信好友</div>
                </div>
                <div class="item">
                    <div class='img friends'>

                    </div>
                    <div class='msg'>分享到朋友圈</div>
                </div>
                <div class="item">
                    <div class='img qq'>

                    </div>
                    <div class='msg'>分享到QQ好友</div>
                </div>
            </div>
            <div class='qrcode primary-bd-d8' v-clickoutside='closeShowQrcode'>
                <div class='img'>
                    <img :src="propsData.qrImg" alt="二维码">
                </div>
                <div class='msg'>扫二维码分享</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as actions from '@/common/js/api.js'
import * as common from '@/common/js/utils.js'

let stats;
export default {
    name: '',
    data() {
        return {
            likes: 0,
            flag: 0,
            isShowQrcode: false,
            isDislike: false,
            url: '',
            timer: '',
            stats: this.$pageStat(this.propsData.seq, 'page_share')
        }
    },
    computed: {
        qrImg() {
            return `http://field.10jqka.com.cn/20191210/c${this.propsData.seq}.shtml`
        },
        isLogin: function () {
            return common.isLogin()
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        this.registerEmitterListener()

    },
    watch: {
        propsData: {
            handler(newVal) {
                this.$nextTick(_ => {
                    this.$utils.judgeScrollDistance(this.$refs.sign, () => {
                        // this.$sendStat(this.stats('sharereveal')) 
                    })
                })
                this.initData(newVal)
                // stats = this.$pageStat( this.propsData.seq, 'page_share');
                // console.log(stats)
            },
            deep: true,
            immediate: true,
        }
    },
    mounted: function () {
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    app: "news",
                    key: "seq_612110504",
                    qrImg: "//news.10jqka.com.cn/pclient/qrcode/300/aHR0cHM6Ly9tLjEwanFrYS5jb20uY24vMjAxOTA2MjQvYzYxMjExMDUwNC5zaHRtbAtsaytsay.png",
                    seq: "612110504",
                    token: "e80d8a1d8e020e9a0121f84eecfe3ef8"
                }
            }
        }
    },
    methods: {
        initData(val) {
            try {
                // this.$commonApi.getLikesInPromise({key: [val.key]}).then( res => {
                // 	if( res.errorcode == 0){
                // 		let obj = res.result[val.key]
                // 		this.likes = obj.likes
                // 		this.flag = obj.flag
                // 	}
                // 	let status = this.$project.getLocalStorage(this.cookieName(), 'v1.0');
                // 	if( typeof status !== 'object'){
                // 		status = {}
                // 	}
                // 	if( status.za == 1){
                // 		this.isDislike = true
                // 	}else{
                // 		this.isDislike = false;
                // 	}
                // 	if( status.zan == 1){
                // 		this.flag = 1
                // 		this.likes++
                // 	}else{
                // 		this.flag = 0
                // 	}
                // })

                // 0.0.9
                commonApi.getLikes({ key: [val.key] }).then(res => {
                    console.log('commomApi文章点赞数', res)
                    if (res.errorcode == 0) {
                        let obj = res.result[val.key]
                        this.likes = obj.likes
                        this.flag = obj.flag
                    }
                    let status = this.$project.getLocalStorage(this.cookieName(), 'v1.0');
                    if (typeof status !== 'object') {
                        status = {}
                    }
                    if (status.za == 1) {
                        this.isDislike = true
                    } else {
                        this.isDislike = false;
                    }
                    if (status.zan == 1) {
                        this.flag = 1
                        this.likes++
                    } else {
                        this.flag = 0
                    }
                })
                this.url = 'http://field.10jqka.com.cn/20191210/c' + val.seq + '.shtml'
            } catch (error) {
                console.log('error', error)
            }

        },
        cookieName() {
            return getAccount() + this.propsData.seq;
        },
        // 点击二维码
        handleWechatSelect() {
            clearTimeout(this.timer)
            // this.$sendStat(this.stats('qrcodeclick'))

            // this.$sendPoint('sys')
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.wxscan.show`);

            this.isShowQrcode = true;
        },
        // 处理赞点击 
        handleZanClick() {
            !this.flag ? this.zan() : this.cancelZan();
        },
        handleZaClick() {
            !this.isDislike ? this.za() : this.cancelZa();
        },
        // 复制链接
        copyCb() {
            this.$client.showBrowserDlgTip({ text: "复制成功!" });
            // this.$sendStat(this.stats('copy'))

            // this.$sendPoint('fzlj')
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.copyurl.click`);

        },
        closeShowQrcode() {
            this.timer = setTimeout(() => {
                this.isShowQrcode = false;
            }, 1000)
        },
        zan() {
            // this.$sendStat(this.stats('praise'))

            // this.$sendPoint('zxdz')
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.praise.click`, { _sid: Math.random() });


            let params = {
                app: this.propsData.app,
                key: this.propsData.key,
                token: this.propsData.token
            }
            this.isDislike ? this.cancelZa() : '';
            // this.$commonApi.ZanInPromise(params).then( res => {
            // 	if( res.errorcode == 0){
            // 		// console.log('文章点赞', res)
            // 	}
            // })

            // 0.0.9
            console.log('文章点赞token', params.token)
            if (this.isLogin) {
                commonApi.addLikes(params).then(res => {
                    console.log('commonApi文章点赞', res)
                    if (res.errorcode == 0) { }
                })
            }
            !this.flag ? this.likes++ : '';
            this.flag = 1;
            // this.$utils.cookieUtil().set(this.cookieName(), JSON.stringify({zan : 1}), 1)
            this.$project.setLocalStorage(this.cookieName(), { zan: 1, za: 0 });
        },
        cancelZan() {
            // this.$sendStat(this.stats('praisecancel'))
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.cancelpraise.click`, { _sid: Math.random() });

            let params = {
                app: this.propsData.app,
                key: this.propsData.key,
                token: this.propsData.token
            }
            this.flag ? this.likes-- : '';
            this.flag = 0;
            // this.$commonApi.cancelZanInPromise(params).then( res => {
            // 	if( res.errorcode == 0){
            // 		// console.log( res)

            // 	}
            // })

            // 0.0.9
            commonApi.delLikes(params).then(res => {
                console.log('commoApi取消文章点赞', res)
                if (res.errorcode == 0) {
                }
            })
            this.$project.setLocalStorage(this.cookieName(), { zan: 0, za: 0 });
        },
        za() {
            // this.$sendStat(this.stats('praisedis'))
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.booing.click`, { _sid: Math.random() });


            // this.$sendPoint('zxza')
            this.isDislike = true;
            this.flag ? this.cancelZan() : '';
            this.$project.setLocalStorage(this.cookieName(), { zan: 0, za: 1 });
        },
        cancelZa() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.cancelbooing.click`, { _sid: Math.random() });
            // this.$sendStat(this.stats('praisediscancel'))
            this.isDislike = false;
            this.$project.setLocalStorage(this.cookieName(), { zan: 0, za: 0 });
        },
        registerEmitterListener() {
            this.$on('HANDLE_RECIVE', (params) => {
                console.log(params)
            })
        },
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/index.less';
.ineract-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 20px 0 20px 0;
    position: relative;
    > .item {
        display: flex;
        > div {
            cursor: pointer;
            display: flex;
            height: 32px;
            box-sizing: border-box;
            padding: 6px 8px 6px 8px;
            border-width: 1px;
            border-style: solid;
            border-radius: 4px;
            align-items: center;
            &:first-child {
                margin-right: 10px;
            }
            > div {
                font-size: 14px;
                height: 19px;
                display: flex;
                align-items: center;
                &:nth-child(2) {
                    margin-left: 8px;
                    background-size: 100% 100%;
                }
                &.weixin {
                    width: 16px;
                    height: 13px;
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/wechaticon.png');
                }
                &.link {
                    width: 13px;
                    height: 13px;
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/link.png');
                }
                &.praise {
                    width: 13px;
                    height: 13px;
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/praise.png');
                }
                &.belittle {
                    width: 13px;
                    height: 13px;
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/belittle.png');
                }
            }
        }
        > .assisted {
            border: 1px solid @profitable;
            border-radius: 4px;
            > .desc {
                color: @profitable;
            }
            .praise {
                background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/praised.png');
            }
        }
        > .belittle {
            border: 1px solid @unprofitable;
            border-radius: 4px;
            > .desc {
                color: @unprofitable;
            }
            > .belittle {
                background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/belittled.png');
            }
        }
    }
    > .qr-block {
        position: absolute;
        top: 10px;
        left: 1px;
        border-radius: 2px;
        box-sizing: border-box;
        transform: translateY(-100%);
        width: 307px;
        height: 152px;
        padding: 4px 12px 4px 12px;
        display: flex;
        justify-content: space-between;
        border: 1px;
        > .share {
            > .item {
                height: 48px;
                display: flex;
                align-items: center;
                > .img {
                    width: 32px;
                    height: 32px;
                    background-size: 100% 100%;
                }
                > .wechat {
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/weixin.png');
                }
                > .friends {
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/friends.png');
                }
                > .qq {
                    background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/qq.png');
                }
                > .msg {
                    font-size: 14px;
                    margin-left: 12px;
                }
            }
        }
        > .qrcode {
            width: 121px;
            height: 123px;
            margin-top: 10px;
            border-left-width: 1px;
            border-left-style: solid;
            > .img {
                margin-left: 20px;
                width: 100px;
                height: 100px;
                > img {
                    width: 100%;
                    height: 100%;
                }
            }
            > .msg {
                margin-left: 20px;
                margin-top: 4px;
                height: 19px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
